import React, { useEffect, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import { Navigate, useLocation } from "react-router-dom"
import axios from "axios"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import Snackbar from "@mui/material/Snackbar"
import Alert from "@mui/material/Alert"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import { useSelector } from "react-redux"
import { logOut } from "../../../utils/logOut"
import Typography from "@mui/material/Typography"
import Switch from "@mui/material/Switch"
import TranslatedText from "../../../utils/Translate"
import { useSnackbar } from "../../../utils/SnackbarContext"

export default function Branch() {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [snackbarType, setSnackbarType] = useState("")
    const [partners, setSPartners] = useState([])

    const { showSnackbar } = useSnackbar();

    //Get params from URL
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    const type: string | null = params.get('type')

    //Get access level
    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )



    useEffect(() => {
        //Switch header title
        dispatch(setCurrentPage(type === "edit" ? `Edit Branch: ${id}` : 'Add Branch'))
    }, [dispatch]);


    //Handle close snackbar
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    //Get branch
    async function fetchData(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/branch/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            if (response.data !== null) {
                setBranchData(response.data[0])
            }

            console.log(response.data[0]);

        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Create branch
    async function postData(data: any = {}) {
        try {
            const response = await axios.post(`https://cardgarantsales.com/restapi/branch`, {
                ...branchData
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Edit branch
    async function putData(data: any = {}) {
        try {
            const response = await axios.put(`https://cardgarantsales.com/restapi/branch/${id}`, {
                ...branchData
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    const [branchData, setBranchData] = useState<any>(type === 'edit' ? [] :
        {
            "branchname": null,
            "partner": null,
        }
    )

    //Get partners for Select field
    async function getPartners(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/partner`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setSPartners(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }



    //On load if URL params contains type=edit - get contactgroup data, if accesslevel = 5 - get partners for Select field
    useEffect(() => {
        type === 'edit' && fetchData()
        accesslevel === "5" && getPartners()
        console.log(branchData);

    }, [])

    return (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <Box>
                <Box sx={{ width: 220, display: "flex", mb: 2, flexWrap: "wrap", gap: 2 }}>
                    <TextField error={branchData.branchname === null} onChange={(e) => setBranchData({ ...branchData, branchname: e.target.value !== '' ? e.target.value : null })} value={branchData.branchname || ''} variant="outlined" size="small" label={<><TranslatedText text={'Branch name'} />*</>} />
                    {Number(accesslevel) === 5 &&
                        <>
                            <FormControl>
                                <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Partner'} />*</InputLabel>
                                <Select sx={{ width: 223 }} labelId="simple-select-label" onChange={(e) => setBranchData({ ...branchData, partner: e.target.value !== "" ? e.target.value : null })} value={branchData.partner || ''} variant="outlined" size="small" label={<><TranslatedText text={'Partner'} />*</>} >
                                    <MenuItem value={''}><TranslatedText text={'Not selected'} /></MenuItem>
                                    {
                                        partners.map((el: any) => {
                                            return (
                                                <MenuItem key={el.id} value={el.id}>{el.partnerbankcode}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                        </>
                    }
                </Box>
                <Button onClick={() => type === "edit" ? putData(branchData) : postData(branchData)} variant="contained" sx={{ width: "100%" }}><TranslatedText text={'Save'} /></Button>
            </Box>
            {type !== 'edit' && snackbarType === 'success' && <Navigate to='/branches' />}
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleClose}>
                {snackbarType === 'error' ?
                    <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                        <TranslatedText text={'Saving error'} />
                    </Alert> :
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                        <TranslatedText text={'Successfully saved'} />
                    </Alert>}
            </Snackbar>
        </Box >
    )
}